<template>
  <div class="mt-5">
    <button class="btn" @click="downloadZip">Create and download ZIP</button>
  </div>
</template>

<script setup lang="ts">
import CaseDef from '../types/CaseDef';
import { downloadAll } from './downloadZip';

const props = defineProps<{ caseDef: CaseDef }>();

function downloadZip() {
  downloadAll(props.caseDef);
}
</script>
